<template>
  <h1 class="h3 container-title">{{ pageName }}</h1>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Title',
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['pageName'])
  }
}
</script>
